<template>
	<div v-loading.fullscreen.lock="visible.loading" element-loading-background="rgba(0, 0, 0, 0.4)">
		<!--<div v-if="!visible.print">-->
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item><i class="icon-lx-calendar"></i> 门禁业务</el-breadcrumb-item>
				<el-breadcrumb-item>卡片业务</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<div class="container">
			<el-row>
				<el-col :span="5">
					<div class="handle-box">
						<el-input placeholder="单位名称" suffix-icon="el-icon-search" v-model.lazy="data.filterDeptStr"
							@change="filterDept" size="large" clearable>
							<el-checkbox slot="prepend" v-model="data.containSubEmployee"
								@change="changeContainSubEmployee">包含下级</el-checkbox>
						</el-input>
					</div>
					<div style="max-height:600px;overflow:auto;">
						<el-tree ref="depts" :data="data.depts" node-key="id" :check-on-click-node="true"
							highlight-current :expand-on-click-node="false" @node-click="handleDeptNodeClick"
							:filter-node-method="handleTreeFilter">
							<span class="span-ellipsis" slot-scope="{ node, data }">
								<span :title="node.label">{{ node.label }}</span>
							</span>
						</el-tree>
					</div>
				</el-col>
				<el-col :span="1">
					&nbsp;
				</el-col>
				<el-col :span="18">
					<div class="handle-box">
						<el-checkbox-group class=" left mr10" v-model="data.search.empType" size="mini">
							<el-checkbox-button :label="1">员工</el-checkbox-button>
							<el-checkbox-button :label="2">保运</el-checkbox-button>
							<el-checkbox-button :label="4">外协</el-checkbox-button>
							<el-checkbox-button :label="9">临时</el-checkbox-button>
						</el-checkbox-group>
						<el-checkbox-group class="left mr10" v-model="data.search.status" size="mini">
							<el-checkbox-button :label="8">正常</el-checkbox-button>
							<el-checkbox-button :label="7">挂失</el-checkbox-button>
							<el-checkbox-button :label="3">过期</el-checkbox-button>
							<el-checkbox-button :label="2">注销</el-checkbox-button>
							<el-checkbox-button :label="5">停用</el-checkbox-button>
						</el-checkbox-group>
						<el-checkbox-group class="left mr10" v-model="data.search.pos" size="mini">
							<el-checkbox-button :label="1">有消费</el-checkbox-button>
							<el-checkbox-button :label="0">无消费</el-checkbox-button>
						</el-checkbox-group>
						<!--<el-date-picker v-model="data.daterange" value-format="yyyy-MM-dd" type="daterange" size="large" :clearable="false"
							class="left mr10" style="width:500px" start-placeholder="开始创建时间" end-placeholder="结束创建时间">
						</el-date-picker>-->
						<el-input class="mr10" v-model="data.search.filterstr" placeholder="姓名/身份证/物理卡号" size="large"
							style="width:340px;" @change="search(true)">
							<el-button slot="append" type="primary" icon="if-lcon-duqushenfenzheng"
								@click="readFromIdCardReader"></el-button>
						</el-input>
						<el-button class="mr10" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
					</div>
					<div class="handle-box">
						<el-button type="primary" icon="if-lcon-faka" @click="toBatchCard" v-if="power.batchcard"
							:disabled="data.selections.length == 0">批量发卡
						</el-button>
						<el-button type="primary" icon="if-lcon-dayin" @click="toBatchPrint" v-if="power.batchprint"
							:disabled="data.selections.length == 0">批量打印
						</el-button>
						<el-button type="primary" icon="if-lcon-faka" @click="toCardPrint" v-if="power.cardprint"
							:disabled="data.selections.length == 0">打印&换卡
						</el-button>
						<el-button type="primary" icon="if-lcon-renyuanleibie" @click="toChangeType"
							v-if="power.changetype" :disabled="data.selections.length == 0">变更类别
						</el-button>
						<el-button type="primary" icon="if-lcon-shouquan" @click="toChangeRight"
							v-if="power.changerihgt" :disabled="data.selections.length == 0">变更权限
						</el-button>
						<el-button type="primary" icon="if-lcon-renlian" @click="toSyncFace" v-if="power.syncface"
							:disabled="data.selections.length != 1">变更照片
						</el-button>
						<!--<el-button class="mr10" type="danger" icon="icon-lx-delete" @click="doDeleteEmployee"
							v-if="power.deleteemp" :disabled="data.selections.length != 1">删除人员
						</el-button>-->
						<el-button type="danger" icon="if-lcon-guashi" @click="toLose"
							v-if="power.lose && data.selections.length == 1 && (data.selections[0].status == '正常卡' || data.selections[0].status == '过期卡')"
							:disabled="data.selections.length == 0 || data.selections.length != 1 || data.selections[0].status != '正常卡' && data.selections[0].status != '过期卡'">
							挂失
						</el-button>
						<el-button type="primary" icon="if-lcon-jiegua" @click="toUnlose"
							v-if="power.unlose && data.selections.length == 1 && data.selections[0].status == '挂失卡'"
							:disabled="data.selections.length == 0 || data.selections.length != 1 || data.selections[0].status != '挂失卡'">
							解挂
						</el-button>
						<el-button type="danger" icon="if-lcon-zhuxiaorenyuan" @click="toCancelEmp"
							v-if="power.cancelemp && data.selections.length == 1 && data.selections[0].status != '注销卡'"
							:disabled="data.selections.length == 0 || data.selections.length != 1 || data.selections[0].status == '注销卡'">
							注销
						</el-button>
					</div>

					<el-table ref="table" :data="data.rows" border class="table" row-key="id" highlight-current-row
						@current-change="tableCurrentChange" @selection-change="handleSelectionChange"
						@cell-click="handleCellClick" height="500">
						<el-table-column type="selection"></el-table-column>
						<el-table-column prop="headImage" label="照片" width="80">
							<template slot-scope="scope">
								<el-image style="height:50px;" :src="scope.row.headImage"
									:preview-src-list="[scope.row.headImage]"></el-image>
							</template>
						</el-table-column>
						<el-table-column prop="empType" label="类别" width="80">
							<template slot-scope="scope">
								<span v-if="scope.row.empType==1">员工</span>
								<span v-else-if="scope.row.empType==2">保运</span>
								<!--<span v-else-if="scope.row.empType==3">外协常驻</span>-->
								<span v-else-if="scope.row.empType==4">外协</span>
								<span v-else>-</span>
							</template>
						</el-table-column>
						<el-table-column prop="deptName" label="单位" width="180" show-overflow-tooltip>
						</el-table-column>
						<el-table-column prop="name" label="姓名" width="100">
						</el-table-column>
						<el-table-column prop="code" label="人员编号" width="130">
						</el-table-column>
						<el-table-column prop="idno" label="身份证号" width="150">
						</el-table-column>
						<el-table-column prop="sex" label="性别" width="70">
						</el-table-column>
						<el-table-column prop="status" label="人员状态" width="120">
						</el-table-column>
						<el-table-column prop="printNumber" label="打印次数" width="120">
						</el-table-column>
						<el-table-column prop="status" label="消费权限" width="120">
							<template slot-scope="scope">
								<el-tag type="success" v-if="scope.row.canPos">有</el-tag>
								<el-tag type="info" v-else>无</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="validTime" label="有效期" width="140">
						</el-table-column>
						<el-table-column prop="crTime" label="创建时间" width="280">
						</el-table-column>
					</el-table>
					<div class="pagination">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentPageChange"
							:current-page="data.page" :page-sizes="[10,20,50,100,200,300,400,500,1000,2000]"
							:page-size="data.size" layout="total, sizes, prev, pager, next, jumper" :total="data.total">
						</el-pagination>
					</div>
				</el-col>
			</el-row>
		</div>
		<el-dialog title="人员换卡" :visible.sync="visible.changeCard" :close-on-click-modal="false" width="510px">
			<el-form @submit.native.prevent label-width="140px">
				<el-form-item label="部门/单位">
					<el-input v-model="data.info.deptName" size="large" readonly></el-input>
				</el-form-item>
				<el-row>
					<el-col :span="16">
						<el-form-item label="人员编号">
							<el-input v-model="data.info.code" size="large" readonly></el-input>
						</el-form-item>
						<el-form-item label="姓名">
							<el-input v-model="data.info.name" size="large" readonly></el-input>
						</el-form-item>
						<el-form-item label="人员类别">
							<el-input v-model="data.info.empType" size="large" readonly></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="1">
						&nbsp;
					</el-col>
					<el-col :span="7">
						<el-image :src="'/image/facepic/' + data.info.idno + data.info.name + '.jpg'"></el-image>
					</el-col>
				</el-row>
				<el-form-item label="原卡号1">
					<el-input v-model="data.info.cardId1" size="large" placeholder="未发卡" readonly></el-input>
				</el-form-item>
				<el-form-item label="原卡号2">
					<el-input v-model="data.info.cardNo1" size="large" placeholder="未发卡" readonly></el-input>
				</el-form-item>
				<el-form-item>
					<img src="../../assets/img/ok.png" width="50" v-if="data.handle.cardTxtFocusStatus" />
					<img src="../../assets/img/warning.png" width="50" @click="toFocusCardId" v-else />
				</el-form-item>
				<el-form-item label="待发卡号1">
					<el-input ref="txtCardId" v-model="data.info.cardId" size="large" @blur="blurCardTxt"
						@focus="focusCardTxt" @keyup.enter.native="handleCardIdChange"
						:disabled="!data.handle.cardinput"></el-input>
				</el-form-item>
				<el-form-item label="待发卡号2">
					<el-input ref="txtCardNo" v-model="data.info.cardNo" size="large" @blur="blurCardTxt"
						@focus="focusCardTxt" @keyup.enter.native="handleCardNoChange"
						:disabled="!data.handle.cardinput"></el-input>
				</el-form-item>
				<el-form-item label="换卡备注">
					<el-input v-model="data.info.remark" size="large" type="textarea" :rows="2"></el-input>
				</el-form-item>
			</el-form>
			<!--<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="" v-if="data.handle.card && data.handle.print">保存&打印预览</el-button>
				<el-button @click="">取 消</el-button>
			</span>-->
		</el-dialog>
		<!--</div>
		<div v-else>
			
		</div>-->

		<el-dialog title="变更类别" :visible.sync="visible.changeType" v-if="power.changetype" width="600px" center
			:close-on-click-modal="false">
			<el-form @submit.native.prevent label-width="140px">
				<el-form-item label="部门/单位">
					<el-input v-model="data.info.deptName" size="large" readonly></el-input>
				</el-form-item>
				<el-form-item label="人员编号">
					<el-input v-model="data.info.code" size="large" readonly></el-input>
				</el-form-item>
				<el-form-item label="姓名">
					<el-input v-model="data.info.name" size="large" readonly></el-input>
				</el-form-item>
				<el-form-item label="门禁类别">
					<el-input v-model="data.info.empType" size="large" readonly></el-input>
				</el-form-item>
				<el-form-item label="消费类别">
					<el-radio-group v-model="data.info.posType">
						<el-radio-button :label="1">员工</el-radio-button>
						<el-radio-button :label="2">保运(固定)</el-radio-button>
						<el-radio-button :label="4">外协(固定)</el-radio-button>
						<el-radio-button :label="10">标准送餐(18)</el-radio-button>
						<!--<el-radio-button :label="9">临时</el-radio-button>-->
						<el-radio-button :label="18">招待</el-radio-button>
						<el-radio-button :label="19">加班</el-radio-button>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="消费权限">
					<el-radio-group v-model="data.handle.pos" :disabled="data.handle.chkPos && data.handle.pos == 1">
						<el-radio-button :label="1">有</el-radio-button>
						<el-radio-button :label="0">无</el-radio-button>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="手机号">
					<el-input v-model="data.info.mobilePhone" size="large"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="doChangeType">保存数据</el-button>
				<el-button @click="visible.changeType = false">取 消</el-button>
			</span>
		</el-dialog>

		<el-dialog title="权限变更" :visible.sync="visible.changeRight" v-if="power.changerihgt" width="1280px" center
			:close-on-click-modal="false">
			<el-form @submit.native.prevent label-width="140px">
				<el-form-item label="授权类型" v-if="data.authorize.type != -1">
					<el-radio-group v-model="data.authorize.type" @change="changeAuthorizeType">
						<el-radio-button :label="1">加权</el-radio-button>
						<el-radio-button :label="0">消权</el-radio-button>
					</el-radio-group>
				</el-form-item>
				<el-form-item>
					<el-tag v-if="data.authorize.type == 1" type="success" size="large">注意：当前加权操作<span
							style="font-weight:bold;font-size:34px !important;">增加勾选的通行权限</span></el-tag>
					<el-tag v-else-if="data.authorize.type == 0" type="warning" size="large">注意：当前取消权操作，<span
							style="font-weight:bold;font-size:34px !important;">勾哪个取消哪个</span></el-tag>
				</el-form-item>
				<el-form-item label="门岗授权">
					<el-table ref="authorize" border class="inner-authorize-table" :data="data.authorizeDatas">
						<el-table-column prop="label" label="" width="100" align="right"></el-table-column>
						<el-table-column v-for="(item,index) in data.authorizeGroups" :prop="'c-' + item.id"
							:key="item.id" :label="item.name" width="120" header-align="center" align="center">
							<template slot-scope="scope">
								<input type="checkbox" style="width:30px;height:30px;"
									:checked="data.authorizeChecks[scope.$index][index]"
									@change="changeAuthorizeChecked" :name="scope.$index + '_' + index"
									:disabled="data.authorize.type == 1 && data.authorizeGroupsChecked[scope.$index][index] || data.authorize.type == 0 && !data.authorizeGroupsChecked[scope.$index][index]" />
							</template>
						</el-table-column>
					</el-table>
				</el-form-item>
				<el-form-item label="门禁点授权">
					<el-checkbox v-model="data.onlyShowSelectDoor">仅显示勾选项</el-checkbox>
					<el-input v-model="data.filterDoor" size="large" placeholder="请输入门禁点名称搜索">
					</el-input>
					<el-table ref="doors"
						:data="data.authorizeDoors.filter(d => (!data.filterDoor || d.doorName.toLowerCase().includes(data.filterDoor.toLowerCase())) && (!data.onlyShowSelectDoor || data.doorselections.indexOf(d)>-1))"
						border class="table" row-key="id" highlight-current-row height="230"
						@selection-change="doorHandleSelectionChange" @cell-click="doorHandleCellClick">
						<el-table-column type="selection" width="50" reserve-selection
							:selectable="checkDoorSelectable"></el-table-column>
						<el-table-column prop="name" label="权限组名称">
						</el-table-column>
						<el-table-column prop="groupNo" label="权限组编号" width="150">
						</el-table-column>
					</el-table>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="doChangeRight">保存数据</el-button>
				<el-button @click="visible.changeRight = false">取 消</el-button>
			</span>
		</el-dialog>

		<el-dialog title="变更照片" :visible.sync="visible.syncFace" v-if="power.syncface" width="800px" center
			:close-on-click-modal="false">
			<el-row>
				<el-col :span="18">
					<img :src="data.face.img" style="height:400px;width:100%;object-fit:contain;" />
				</el-col>
				<el-col :span="6">
					<el-button type="primary" @click="cameraImage" style="width:200px;margin:2px 2px 2px 10px;">拍照
					</el-button>
					<el-button type="primary" @click="loadLocationImage" style="width:200px;margin:2px 2px 2px 10px;">
						本地上传
					</el-button>
					<el-button type="primary" @click="loadFaceSvcImage" style="width:200px;margin:2px 2px 2px 10px;">
						脸谱读取
					</el-button>
					<el-button type="primary" @click="toCropper" style="width:200px;margin:2px 2px 2px 10px;">图片裁剪
					</el-button>
				</el-col>
			</el-row>
			<!--<el-checkbox v-model="data.face.saveFaceSvc">保存时覆盖脸谱图片</el-checkbox>-->
			<el-checkbox v-model="data.face.saveCardPhoto">保存时覆盖打卡照片</el-checkbox>
			<el-checkbox v-model="data.face.saveFaceDev">保存时覆盖人脸识别照片</el-checkbox><br /><br />
			注：界面首次打开，<br />
			系统自动获取用户脸谱照片，<br />
			如需更换请按图片下方选项进行更替与确认。
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="doSyncFace">保存照片</el-button>
				<el-button @click="visible.syncFace = false">取 消</el-button>
			</span>
		</el-dialog>

		<takeImage ref="takeImage" @toOk="saveImage" :autoCropWidth="270" :autoCropHeight="378"></takeImage>
		<takeCamera ref="takeCamera" @toOk="saveImage" :autoCropWidth="270" :autoCropHeight="378"></takeCamera>

		<el-dialog title="打印预览" :visible.sync="visible.print" v-if="power.print" width="510px" center
			:close-on-click-modal="false">
			<div id="printCardTemplate">
				<iframe ref="template1" :srcdoc="data.print.template1" width="468px" height="276px" frameborder="0"
					scrolling="no"></iframe>
				<div ref="pageBreak" style="page-break-after:always;" v-if="data.print.template2 != ''"></div>
				<iframe ref="template2" :srcdoc="data.print.template2" width="468px" height="276px" frameborder="0"
					scrolling="no" v-if="data.print.template2 != ''"></iframe>
			</div>
			<!--<span slot="footer" class="dialog-footer" v-if="!data.print.noneprintbutton">
				<el-button type="primary" @click="">打 印</el-button>
				<el-button @click="">取 消</el-button>
			</span>-->
		</el-dialog>
	</div>
</template>

<script>
	import takeImage from '../usercontrol/TakeImage.vue'
	import takeCamera from '../usercontrol/TakeCamera.vue'
	export default {
		name: 'cardbusiness',
		data() {
			return {
				data: {
					depts: [],
					daterange: [],
					total: 0,
					size: 10,
					page: 1,
					rows: [],
					filterDeptStr: '',
					filterDoor: '',
					onlyShowSelectDoor: false,
					curDeptId: '0',
					containSubEmployee: true,
					curEmpId: 0,
					curIdx: 0,
					selections: [],
					doorselections: [],
					search: {
						filterstr: '',
						hasCard: 0,
						status: [7, 8],
						empType: [1, 2, 4, 9],
						pos: [1, 0]
					},
					info: {
						id: 0,
						name: '',
						code: '',
						idno: '',
						deptName: '',
						empType: '-',
						posType: 0,
						cardNo1: '',
						cardId1: '',
						cardNo: '',
						cardId: '',
						remark: '',
						mobilePhone: ''
					},
					print: {
						template1: '',
						template2: '',
						noneprintbutton: false
					},
					handle: {
						pos: -1,
						chkPos: false,
						cardTxtFocusStatus: false,
						cardinput: false,
						batch: false,
						card: false,
						print: false
					},
					authorize: {
						type: 1,
						hasVeh: false,
						empIds: [],
						empNames: ''
					},
					face: {
						img: '',
						//0 - 拍照，   1 - 本地，   2 - 脸谱
						imgType: 0,
						saveFaceSvc: true,
						saveCardPhoto: false,
						saveFaceDev: false
					},
					authorizeHeader: {},
					authorizeGroups: [],
					authorizeDatas: [],
					authorizeGroupsChecked: [],
					authorizeGroupsChecked2: [],
					authorizeChecks: [],
					authorizeDoorsChecked: [],
					authorizeDoorsChecked2: [],
					authorizeDoors: []
				},
				printFrameStatus: {
					checkAllComplateTimer: null,
					pic1IsComplate: false,
					pic2IsComplate: false
				},
				visible: {
					loading: false,
					changeCard: false,
					print: false,
					changeType: false,
					changeRight: false,
					syncFace: false
				},
				power: {
					pageId: 31,
					search: false,
					card: false,
					batchcard: false,
					print: false,
					batchprint: false,
					cardprint: false,
					batchcardprint: false,
					changetype: false,
					changerihgt: false,
					syncface: false,
					deleteemp: false,
					lose: false,
					unlose: false,
					cancelemp: false
				}
			}
		},
		methods: {
			readFromIdCardReader() {
				let ths = this;
				ths.dev.gethsidcardreader(ths, 'data.search.filterstr', 'visible.loading', v => {
					ths.search(true);
				});
			},
			search(change) {
				let ths = this;
				ths.loading = false;
				ths.$refs.table.clearSelection();
				if (change) {
					ths.data.page = 1;
				}
				let empTypeStr = '';
				for (let i = 0; i < ths.data.search.empType.length; i++) {
					empTypeStr += ('&emptype=' + ths.data.search.empType[i]);
				}
				let statusStr = '';
				for (let i = 0; i < ths.data.search.status.length; i++) {
					statusStr += ('&status=' + ths.data.search.status[i]);
				}
				let posStr = '';
				for (let i = 0; i < ths.data.search.pos.length; i++) {
					posStr += ('&pos=' + ths.data.search.pos[i]);
				}
				window.ax.get('api/personnal/employee/pagerlist?deptid=' + ths.data.curDeptId + '&pagesize=' + ths.data.size + 
					statusStr + empTypeStr + posStr + '&currentpage=' + ths.data.page + '&sign=' + window.$gloable.userinfo.sign + 
					'&hascard=' + ths.data.search.hasCard + /*'&startdate=' + ths.data.daterange[0] + '&enddate=' + ths.data.daterange[1] + */
					'&filterStr=' + ths.data.search.filterstr + '&containdown=' + (ths.data.containSubEmployee ? true : false)).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						data = data.data;
						let len = data.datas.length;
						let total = data.totalRecord;
						ths.data.rows = data.datas;
						ths.data.total = total;
						if (len == 0 && total > 0) {
							ths.data.page = Math.ceil(total / ths.data.size);
							ths.search();
						}
					} else {
						ths.$message.error(data.message);
					}
					ths.visible.loading = false;
				}).catch(err => {
					ths.$message.error('执行脚本出错，请联系管理员');
					ths.visible.loading = false;
				});
			},
			handleSelectionChange(selections) {
				this.data.selections = selections;
			},
			handleCellClick(row, column, cell, event) {
				if (column.property != 'opt') {
					this.$refs.table.toggleRowSelection(row, this.data.selections.indexOf(row) == -1);
				}
			},
			tableCurrentChange(row) {
				this.data.curEmpId = row.id;
			},
			doorHandleSelectionChange(selections) {
				this.data.doorselections = selections;
			},
			doorHandleCellClick(row, column, cell, event) {
				if (column.property != 'opt' && (this.data.authorize.type == 1 && this.data.authorizeDoorsChecked.indexOf(
						row.id) == -1 || this.data.authorize.type == 0 && this.data.authorizeDoorsChecked.indexOf(row
						.id) > -1)) {
					this.$refs.doors.toggleRowSelection(row, this.data.doorselections.indexOf(row) == -1);
				}
			},
			handleSizeChange(size) {
				this.data.selections.splice(0, this.data.selections.length);
				this.data.size = size;
				this.data.page = 1;
				this.search();
			},
			handleCurrentPageChange(current) {
				this.data.selections.splice(0, this.data.selections.length);
				this.data.page = current;
				this.search();
			},
			changeContainSubEmployee() {
				this.search(true);
			},
			filterDept() {
				this.data.filterDeptStr = this.data.filterDeptStr.toLowerCase();
				this.$refs.depts.filter(this.data.filterDeptStr);
			},
			handleDeptNodeClick(data, node, target) {
				let ths = this;
				if (ths.data.curDeptId != data.id) {
					ths.data.curDeptId = data.id;
					ths.data.search.filterstr = '';
					ths.search(true);
				}
			},
			handleTreeFilter(value, data, node) {
				if (!value) {
					return true;
				} else {
					return data.label && data.label.toLowerCase().indexOf(value) != -1;
				}
			},
			toFocusCardId() {
				let ths = this;
				ths.data.info.cardId = '';
				ths.data.info.cardNo = '';
				ths.data.handle.cardinput = true;
				setTimeout(() => {
					ths.$refs.txtCardId.focus();
				}, 100);
			},
			blurCardTxt() {
				this.data.handle.cardTxtFocusStatus = false;
			},
			focusCardTxt() {
				this.data.handle.cardTxtFocusStatus = true;
			},
			handleCardIdChange(e) {
				e.target.blur();
				let ths = this;
				if (ths.data.info.cardNo != '') {
					ths.data.info.cardId = '';
					ths.data.info.cardNo = '';
					ths.$message.warning('卡号异常，请等待红色图标变绿色，再进行刷卡');
					ths.data.handle.cardinput = false;
					setTimeout(() => {
						ths.data.handle.cardinput = true;
						setTimeout(function() {
							ths.$refs.txtCardId.focus();
						}, 100);
					}, 3000);
				} else {
					ths.$refs.txtCardNo.focus();
				}
			},
			handleCardNoChange(e) {
				e.target.blur();
				let ths = this;
				if (ths.data.info.cardId == '' || ths.data.info.cardId == ths.data.info.cardNo) {
					ths.data.info.cardId = '';
					ths.data.info.cardNo = '';
					ths.$message.info('卡号异常，请等待红色图标变绿色，再进行刷卡');
					ths.data.handle.cardinput = false;
					setTimeout(() => {
						ths.data.handle.cardinput = true;
						setTimeout(function() {
							ths.$refs.txtCardId.focus();
						}, 100);
					}, 3000);
				} else {
					ths.doSaveCard();
				}
			},
			toBatchCardPrint() {
				let ths = this;
				ths.data.handle.batch = true;
				ths.data.handle.card = true;
				ths.data.handle.print = true;
				ths.data.curIdx = 0;
				ths.toCard();
			},
			toCardPrint() {
				let ths = this;
				ths.data.handle.batch = false;
				ths.data.handle.card = true;
				ths.data.handle.print = true;
				ths.data.curIdx = 0;
				ths.toPrint();
			},
			toBatchCard() {
				let ths = this;
				ths.data.handle.batch = true;
				ths.data.handle.card = true;
				ths.data.handle.print = false;
				ths.data.curIdx = 0;
				ths.toCard();
			},
			toCard() {
				let ths = this;
				let inf = ths.data.selections[ths.data.curIdx];
				let id = inf.id;
				ths.data.info.id = id;
				ths.visible.loading = true;
				window.ax.get('api/personnal/employee/cardinfo?id=' + id + '&sign=' + window.$gloable.userinfo.sign, {})
					.then(rsp => {
						let data = rsp.data;
						if (data.code == 1) {
							data = data.data;
							ths.data.info.code = data.code;
							ths.data.info.name = data.name;
							ths.data.info.idno = data.idno;
							ths.data.info.deptName = data.deptName;
							ths.data.print.template1 = data.html1;
							ths.data.print.template2 = data.html2;
							ths.data.info.cardId1 = data.CardId;
							ths.data.info.cardNo1 = data.CardNo;
							ths.data.info.cardId = '';
							ths.data.info.cardNo = '';
							ths.data.info.empType = data.empType;
							if (inf.status != '挂失卡') {
								ths.$confirm('该人员状态不是挂失卡，请确认是否需要先挂失再换卡？（注：如果已开通消费功能，必须先挂失再换卡，否则将不能正常消费）', {
									confirmButtonText: '是',
									cancelButtonText: '否',
									closeOnClickModal: false
								}).then(() => {
									ths.visible.changeCard = false;
								}).catch(() => {
									ths.visible.changeCard = true;
									setTimeout(ths.toFocusCardId, 100);
								});
							} else {
								ths.visible.changeCard = true;
								setTimeout(ths.toFocusCardId, 100);
							}
						} else {
							ths.$message.error(data.message);
						}
						ths.visible.loading = false;
					}).catch(err => {
						ths.$message.error('执行脚本出错，请联系管理员');
						ths.visible.loading = false;
					});
			},
			doSaveCard() {
				let ths = this;
				ths.visible.loading = true;
				let inf = ths.data.info;
				let opt = {
					Sign: window.$gloable.userinfo.sign,
					EmpId: inf.id,
					CardId: inf.cardId,
					CardNo: inf.cardNo
				};
				window.ax.post('api/personnal/employee/savecard', opt).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						ths.$message.success(data.message);
						++ths.data.curIdx;
						if (ths.data.handle.batch && ths.data.curIdx < ths.data.selections.length) {
							if (ths.data.handle.print) {
								ths.visible.changeCard = false;
								ths.toPrint();
							} else if (ths.data.handle.card) {
								ths.toCard();
							}
						} else {
							ths.visible.changeCard = false;
						}
					} else {
						ths.$message.error(data.message);
						if (data.code == -4) {
							this.toFocusCardId();
						}
					}
					ths.search();
					setTimeout(()=>{
						ths.visible.loading = false;
					},3000);
				}).catch(err => {
					ths.$message.error('执行脚本出错，请联系管理员');
					ths.visible.loading = false;
				});
			},
			doSaveCard1() {
				let ths = this;
				ths.visible.loading = true;
				let inf = ths.data.info;
				let opt = {
					Sign: window.$gloable.userinfo.sign,
					EmpId: inf.id,
					CardId: inf.cardId,
					CardNo: inf.cardNo
				};
				window.ax.post('api/personnal/employee/savecard', opt).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						if (ths.data.handle.print) {
							ths.visible.changeCard = false;
							ths.$message.success(data.message);
							if (ths.data.handle.print) {
								ths.toPrint();
							}
						} else if (ths.data.handle.batch && ths.data.curIdx < ths.data.selections.length - 1) {
							++ths.data.curIdx;
							ths.$message.success(data.message);
							ths.toCard();
						} else {
							ths.$message.success(data.message);
							ths.visible.changeCard = false;
						}
					} else {
						ths.$message.error(data.message);
						if (data.code == -4) {
							this.toFocusCardId();
						}
					}
					ths.visible.loading = false;
				}).catch(err => {
					ths.$message.error('执行脚本出错，请联系管理员');
					ths.visible.loading = false;
				});
			},
			toBatchPrint() {
				let ths = this;
				ths.data.handle.batch = true;
				ths.data.handle.card = false;
				ths.data.handle.print = true;
				ths.data.curIdx = 0;
				ths.toPrint();
			},
			toPrint() {
				let ths = this;
				let inf = ths.data.selections[ths.data.curIdx];
				let id = inf.id;
				ths.data.info.id = id;
				ths.visible.loading = true;
				window.ax.get('api/personnal/employee/cardinfo?id=' + id + '&sign=' + window.$gloable.userinfo.sign, {})
					.then(rsp => {
						let data = rsp.data;
						if (data.code == 1) {
							data = data.data;
							ths.printFrameStatus.pic1IsComplate = false;
							ths.printFrameStatus.pic2IsComplate = false;
							ths.data.print.noneprintbutton = true;
							ths.visible.print = true;
							ths.data.print.template1 = data.html1;
							/*.replace('@@empName@@', data.name).replace(
							'@@empCode@@', data.code).replace('@@deptName@@', data.deptName).replace(
							'@@idno@@', data.idno);*/
							ths.data.print.template2 = data.html2;
							/*.replace('@@empName@@', data.name).replace(
							'@@empCode@@', data.code).replace('@@deptName@@', data.deptName).replace(
							'@@idno@@', data.idno);*/
							let itl = setInterval(function() {
								if (ths.printFrameStatus.pic1IsComplate && (ths.printFrameStatus
										.pic2IsComplate || !ths.data.info.template2)) {
									clearInterval(itl);
									ths.doPrint();
								}
							}, 100);
						} else {
							ths.$message.error(data.message);
						}
						ths.visible.loading = false;
					}).catch(err => {
						ths.$message.error('执行脚本出错，请联系管理员');
						ths.visible.loading = false;
					});
			},
			doPrint() {
				let ths = this;
				if (ths.$refs.pageBreak && ths.$refs.pageBreak.style["breakAfter"]) {
					ths.$refs.pageBreak.style["breakAfter"] = "";
					ths.$refs.pageBreak.style["pageBreakAfter"] = "always";
				}
				ths.$print(document.getElementById('printCardTemplate'), {
					noneGlobalStyle: true,
					callback: () => {
						ths.addPrintNumber(ths.data.info.id);
						if (ths.data.handle.card) {
							setTimeout(function() {
								ths.visible.print = false;
								ths.data.print.noneprintbutton = false;
								ths.toCard();
							}, 100);
						} else if (ths.data.handle.batch) {
							ths.data.print.noneprintbutton = false;
							++ths.data.curIdx;
							if (ths.data.curIdx < ths.data.selections.length) {
								ths.toPrint();
							} else {
								ths.visible.print = false;
								ths.$message.success('打印完成');
							}
						}
					}
				});
			},
			doPrint1() {
				let ths = this;
				if (ths.$refs.pageBreak && ths.$refs.pageBreak.style["breakAfter"]) {
					ths.$refs.pageBreak.style["breakAfter"] = "";
					ths.$refs.pageBreak.style["pageBreakAfter"] = "always";
				}
				ths.$print(document.getElementById('printCardTemplate'), {
					noneGlobalStyle: true,
					callback: () => {
						ths.addPrintNumber(ths.data.info.id);
						if (ths.data.handle.card) {
							setTimeout(function() {
								ths.visible.print = false;
								ths.data.print.noneprintbutton = false;
								++ths.data.curIdx;
								if (ths.data.curIdx < ths.data.selections.length) {
									ths.toCard();
								} else {
									ths.$message.success('打印完成');
								}
							}, 100);
						} else if (ths.data.handle.batch) {
							ths.data.print.noneprintbutton = false;
							++ths.data.curIdx;
							if (ths.data.curIdx < ths.data.selections.length) {
								ths.toPrint();
							} else {
								ths.visible.print = false;
								ths.$message.success('打印完成');
							}

						}
					}
				});
			},
			addPrintNumber(empId) {
				let opt = {
					Sign: window.$gloable.userinfo.sign,
					EmpId: empId
				};
				window.ax.post('api/personnal/employee/addprintnumber', opt);
			},
			checkPrintFramesStatus() {
				let ths = this;
				ths.printFrameStatus.checkAllComplateTimer = setInterval(function() {
					if (ths.visible.print) {
						let fPic1 = ths.$refs.template1;
						let fPic2 = ths.$refs.template2;
						if (fPic1) {
							let cmp = fPic1.contentDocument.readyState == "complete";
							if (ths.printFrameStatus.pic1IsComplate != cmp) {
								ths.printFrameStatus.pic1IsComplate = cmp;
							}
						}
						if (fPic2) {
							let cmp = fPic2.contentDocument.readyState == "complete";
							if (ths.printFrameStatus.pic2IsComplate != cmp) {
								ths.printFrameStatus.pic2IsComplate = cmp;
							}
						}
					}
				}, 1000);
			},
			toChangeType() {
				let ths = this;
				ths.visible.loading = true;
				if (ths.data.selections.length == 1) {
					let inf = ths.data.selections[0];
					let id = inf.id;
					ths.data.info.id = id;
					window.ax.get('api/personnal/employee/cardinfo?id=' + id + '&sign=' + window.$gloable.userinfo
							.sign, {})
						.then(rsp => {
							let data = rsp.data;
							if (data.code == 1) {
								data = data.data;
								ths.data.info.code = data.code;
								ths.data.info.name = data.name;
								ths.data.info.idno = data.idno;
								ths.data.info.deptName = data.deptName;
								ths.data.info.posType = data.type;
								ths.data.info.empType = data.empType;
								ths.data.info.mobilePhone = data.mobilePhone;
								if (data.canPos) {
									ths.data.handle.pos = 1;
									ths.data.handle.chkPos = true;
								} else {
									ths.data.handle.pos = 0;
									ths.data.handle.chkPos = false;
								}
								ths.visible.changeType = true;
							} else {
								ths.$message.error(data.message);
							}
							ths.visible.loading = false;
						}).catch(err => {
							ths.$message.error('执行脚本出错，请联系管理员');
							ths.visible.loading = false;
						});
				} else {
					ths.data.info.code = "";
					ths.data.info.name = "";
					ths.data.info.idno = "";
					ths.data.info.deptName = "批量修改";
					ths.data.info.posType = ths.data.selections[0].empType;
					ths.data.handle.pos = ths.data.selections[0].canPos ? 1 : 0;
					ths.data.info.empType = "";
					ths.visible.changeType = true;
					ths.visible.loading = false;
				}
			},
			doChangeType() {
				let ths = this;
				let inf = ths.data.info;
				let ids = [];
				for (var i = 0; i < ths.data.selections.length; i++) {
					ids.push(ths.data.selections[i].id);
				}
				//let id = inf.id;
				ths.visible.loading = true;
				let opt = {
					ids: ids,
					str: inf.posType,
					sign: window.$gloable.userinfo.sign,
					pos: ths.data.handle.pos == 1,
					mobilePhone: inf.mobilePhone
				};
				window.ax.post('api/personnal/employee/changeEmpType', opt)
					.then(rsp => {
						let data = rsp.data;
						if (data.code == 1) {
							ths.$message.success(data.message);
							ths.visible.changeType = false;
						} else {
							ths.$message.error(data.message);
						}
						ths.visible.loading = false;
					}).catch(err => {
						ths.$message.error('执行脚本出错，请联系管理员');
						ths.visible.loading = false;
					});
			},
			toChangeRight() {
				let ths = this;
				ths.visible.loading = true;
				for (let i = 0; i < 2; i++) {
					ths.data.authorizeGroupsChecked[i] = [];
					for (let j = 0; j < ths.data.authorizeChecks[i].length; j++) {
						ths.data.authorizeChecks[i][j] = false;
						ths.data.authorizeGroupsChecked[i][j] = false;
					}
				}
				ths.data.authorizeDoorsChecked = [];
				if (ths.data.selections.length == 1) {
					let inf = ths.data.selections[0];
					let id = inf.id;
					ths.data.authorize.empIds = [id];
					ths.data.info.id = id;
					window.ax.get('api/personnal/employee/getRight?id=' + id + '&sign=' + window.$gloable.userinfo
							.sign, {})
						.then(rsp => {
							let data = rsp.data;
							if (data.code == 1) {
								data = data.data;
								ths.data.authorize.hasVeh = data.hasVeh;
								ths.data.authorize.type = 1;
								let auth = data.groupNos;
								let firstRow = ths.data.authorizeHeader;
								for (let prop in firstRow) {
									for (let i = 0; i < auth.length; i++) {
										let item = auth[i];
										if (prop.indexOf('-' + item[0] + '-') > -1) {
											let idx = firstRow[prop];
											//if (prop.indexOf('V') == -1 && idx != undefined) {
											if (item[1] == 1) {
												ths.data.authorizeChecks[0][idx] = true;
												ths.data.authorizeGroupsChecked[0][idx] = true;
											}
											if (item[2] == 1) {
												ths.data.authorizeChecks[1][idx] = true;
												ths.data.authorizeGroupsChecked[1][idx] = true;
											}
											//if (item[3] == 1) {
											//	ths.data.authorizeChecks[2][idx] = true;
											//}
											//} else {
											//	if (item[4] == 1) {
											//		ths.data.authorizeChecks[2][idx] = true;
											//	}
											//}
										}
									}
								}
								let doorIds = data.doorIds;
								ths.data.authorizeDoorsChecked = [];
								for (var i = 0; i < doorIds.length; i++) {
									ths.data.authorizeDoorsChecked.push(doorIds[i]);
								}
								ths.data.authorizeGroupsChecked2 = JSON.parse(JSON.stringify(ths.data
									.authorizeGroupsChecked));
								ths.data.authorizeDoorsChecked2 = JSON.parse(JSON.stringify(ths.data
									.authorizeDoorsChecked));
								ths.visible.changeRight = true;
								setTimeout(() => {
									this.$refs.doors.clearSelection();
									for (var i = 0; i < ths.data.authorizeDoors.length; i++) {
										let d = ths.data.authorizeDoors[i];
										if (doorIds.indexOf(d.id) > -1) {
											this.$refs.doors.toggleRowSelection(d, true);
										}
									}
								}, 100);
							} else {
								ths.$message.error(data.message);
							}
							ths.visible.loading = false;
						}).catch(ex => {
							ths.$message.error('执行脚本出错，请联系管理员');
							ths.visible.loading = false;
						});
				} else {
					ths.data.authorize.type = 1;
					ths.data.authorize.empIds.splice(0, ths.data.authorize.empIds.length);
					for (let i = 0; i < ths.data.selections.length; i++) {
						ths.data.authorize.empIds.push(ths.data.selections[i].id);
					}
					ths.visible.changeRight = true;
					setTimeout(() => {
						this.$refs.doors.clearSelection();
					}, 100)
					ths.visible.loading = false;
				}
			},
			doChangeRight() {
				let ths = this;
				ths.visible.loading = true;
				let emps = [];
				let authorizes = [];
				let h = ths.data.authorizeHeader;
				let d = ths.data.authorizeDatas[0];
				for (let c in h) {
					if (c != 'label') {
						let idx = h[c];
						let arr = c.split('-');
						for (let i = 0; i < arr.length; i++) {
							let groupNo = arr[i];
							if (groupNo != 'c' && groupNo != 'cV' && groupNo != '') {
								if (idx != undefined) {
									let check1 = ths.data.authorizeChecks[0][idx];
									let check2 = ths.data.authorizeChecks[1][idx];
									//let check3 = ths.data.authorizeChecks[2][idx];
									//let check4 = false;
									//if (ths.data.info.hasVehicle) {
									//	check4 = ths.data.authorizeChecks[2][idx];
									//}
									authorizes.push([groupNo, check1 ? 1 : 0, check2 ? 1 : 0, 0, 0]);
								}
							}
						}
					}
				}
				let groups = [];
				for (var i = 0; i < ths.data.doorselections.length; i++) {
					groups.push(ths.data.doorselections[i].id);
				}
				let opt = {
					Sign: window.$gloable.userinfo.sign,
					EmpIds: ths.data.authorize.empIds,
					Type: ths.data.authorize.type,
					Authorizes: authorizes,
					Groups: groups
				};
				window.ax.post('api/personnal/employee/saveauthorize', opt).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						ths.$message.success(data.message);
						ths.visible.changeRight = false;
					} else {
						ths.$message.error(data.message);
					}
					ths.visible.loading = false;
				}).catch(err => {
					console.log(err);
					ths.visible.loading = false;
				});
			},
			checkDoorSelectable(r, idx) {
				let ths = this;
				if (ths.data.authorize.type == 1) {
					return ths.data.authorizeDoorsChecked.indexOf(r.id) == -1;
				} else {
					return ths.data.authorizeDoorsChecked.indexOf(r.id) > -1;
				}
			},
			toSyncFace() {
				let ths = this;
				let inf = ths.data.selections[0];
				let id = inf.id;
				ths.data.info.id = id;
				ths.data.info.idno = inf.idno;
				ths.loadFaceSvcImage();
				ths.visible.syncFace = true;
				/*
				ths.visible.loading = true;
				window.ax.get('api/personnal/employee/faceInfo?id=' + id + '&sign=' + window.$gloable.userinfo.sign, {}).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						ths.data.face.img = data.data.img;
						ths.visible.syncFace = true;
					} else {
						ths.$message.error(data.message);
					}
					ths.visible.loading = false;
				}).catch(ex => {
					ths.$message.error('执行脚本出错，请联系管理员');
					ths.visible.loading = false;
				});
				*/
			},
			doSyncFace() {
				let ths = this;
				let id = ths.data.info.id;
				ths.visible.loading = true;
				let opt = {
					sign: window.$gloable.userinfo.sign,
					empId: id,
					image: ths.data.face.img,
					saveFaceSvc: ths.data.face.saveFaceSvc,
					saveFaceDev: ths.data.face.saveFaceDev,
					saveCardPhoto: ths.data.face.saveCardPhoto
				};
				window.ax.post('/api/personnal/employee/saveFaceInfo', opt).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						ths.$message.success(data.message);
						ths.visible.syncFace = false;
					} else {
						ths.$message.error(data.message);
					}
					ths.visible.loading = false;
				}).catch(ex => {
					ths.$message.error('执行脚本出错，请联系管理员');
					ths.visible.loading = false;
				});
			},
			doDeleteEmployee() {
				let ths = this;
				let inf = ths.data.selections[0];
				let id = inf.id;
				ths.$confirm('请确认是否删除该人员信息（' + inf.deptName + '-' + inf.name + '）', '提示').then(o => {
					let opt = {
						Sign: window.$gloable.userinfo.sign,
						id: id
					};
					window.ax.post('api/personnal/employee/deleteEmployee', opt).then(rsp => {
						if (rsp.data.code == 1) {
							ths.search(false);
						}
					});
				}).catch(o => {});
			},
			toLose() {
				let ths = this;
				let inf = ths.data.selections[0];
				let id = inf.id;
				ths.$confirm('请确认是否挂失该人员的卡片信息（' + inf.deptName + '-' + inf.name + '）', '提示').then(o => {
					debugger
					ths.doLose(id, 1);
				}).catch(o => {});
			},
			toUnlose() {
				let ths = this;
				let inf = ths.data.selections[0];
				let id = inf.id;
				ths.$confirm('请确认是否解挂该人员的卡片信息（' + inf.deptName + '-' + inf.name + '）', '提示').then(o => {
					ths.doLose(id, 0);
				}).catch(o => {});
			},
			doLose(id, status) {
				let ths = this;
				let opt = {
					Sign: window.$gloable.userinfo.sign,
					id: id,
					idStr: status
				};
				window.ax.post('api/personnal/employee/loseCard', opt).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						ths.$message.success(data.message);
						ths.search();
					} else {
						ths.$message.error(data.message);
					}
					ths.visible.loading = false;
				}).catch(ex => {
					ths.$message.error('执行脚本出错，请联系管理员');
					ths.visible.loading = false;
				});
			},
			toCancelEmp() {
				let ths = this;
				let inf = ths.data.selections[0];
				let id = inf.id;
				ths.visible.loading = true;
				if (inf.empType == 1) {
					ths.$prompt('请输入管理密码', '提示', { confirmButtonText: '确定', cancelButtonText: '取消' }).then(
						({ value }) => {
							window.ax.post('api/authorize/powers/checkAdminCustomerPwd', { Sign: window.$gloable.userinfo.sign, idStr: value }).then(rsp => {
								if (rsp.data == 1) {
									ths.$confirm('请确认是否注销该人员信息（' + inf.deptName + '-' + inf.name + '），注销后该人员的所有门禁权限、车卡权限将一并取消。', '提示').then(
										o => {
											ths.doCancelEmp(id);
											ths.visible.loading = false;
										}
									).catch(o => {
										ths.visible.loading = false;
									});
								} else {
									ths.$message.error('管理密码验证失败');
									ths.visible.loading = false;
								}
							}).catch(ex => {
								ths.$message.error('执行脚本出错，请联系管理员');
								ths.visible.loading = false;
							});
						}
					).catch(o => {
						ths.visible.loading = false;
					});
				} else {
					ths.$confirm('请确认是否注销该人员信息（' + inf.deptName + '-' + inf.name + '），注销后该人员的所有门禁权限、车卡权限将一并取消。', '提示').then(
						o => {
							ths.doCancelEmp(id);
							ths.visible.loading = false;
						}
					).catch(o => {
						ths.visible.loading = false;
					});
				}
			},
			doCancelEmp(id) {
				let ths = this;
				let opt = {
					Sign: window.$gloable.userinfo.sign,
					id: id
				};
				window.ax.post('api/personnal/employee/cancelEmployee', opt).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						ths.$message.success(data.message);
						ths.search();
					} else {
						ths.$message.error(data.message);
					}
					ths.visible.loading = false;
				}).catch(ex => {
					ths.$message.error('执行脚本出错，请联系管理员');
					ths.visible.loading = false;
				});
			},
			changeAuthorizeType(val) {
				let ths = this;
				return;
				this.$refs.doors.clearSelection();
				if (val == 1) {
					for (let i = 0; i < ths.data.authorizeGroupsChecked2.length; i++) {
						for (let j = 0; j < ths.data.authorizeGroupsChecked2[i].length; j++) {
							ths.data.authorizeGroupsChecked[i][j] = ths.data.authorizeGroupsChecked2[i][j];
							ths.data.authorizeChecks[i][j] = ths.data.authorizeGroupsChecked2[i][j];
						}
					}
					//ths.data.authorizeGroupsChecked = JSON.parse(JSON.stringify(ths.data.authorizeGroupsChecked2));
					ths.data.authorizeDoorsChecked = JSON.parse(JSON.stringify(ths.data.authorizeDoorsChecked2));
					for (var i = 0; i < ths.data.authorizeDoorsChecked.length; i++) {
						this.$refs.doors.toggleRowSelection(ths.data.authorizeDoorsChecked[i], true);
					}
				} else if (val == 0) {
					for (let i = 0; i < ths.data.authorizeGroupsChecked.length; i++) {
						for (let j = 0; j < ths.data.authorizeGroupsChecked[i].length; j++) {
							ths.data.authorizeGroupsChecked[i][j] = false;
						}
					}
					for (let i = 0; i < ths.data.authorizeChecks.length; i++) {
						for (let j = 0; j < ths.data.authorizeChecks[i].length; j++) {
							ths.data.authorizeChecks[i][j] = false;
						}
					}
					ths.data.authorizeDoorsChecked = [];
				}
			},
			changeAuthorizeChecked(e) {
				let chked = e.target.checked;
				let pars = e.target.name.split('_');
				let row_idx = Number(pars[0]);
				let col_idx = Number(pars[1]);
				this.data.authorizeChecks[row_idx][col_idx] = chked;
			},
			blobToBase64(blob) {
				return new Promise((resolve, reject) => {
					const reader = new FileReader();
					reader.onload = e => {
						resolve(e.target.result);
					};
					reader.onerror = () => {
						reject(new Error('文件流异常'));
					}
					reader.readAsDataURL(blob);
				});
			},
			cameraImage() {
				let ths = this;
				this.$refs.takeCamera.init();
			},
			loadLocationImage() {
				this.$refs.takeImage.init();
			},
			saveImage(img, type) {
				let ths = this;
				if (type == 'camera') {
					ths.data.face.imgType = 0;
				} else if (type == 'location') {
					ths.data.face.imgType = 1;
				}
				ths.blobToBase64(img).then(r => {
					ths.data.face.img = r;
					ths.data.face.imgType = 2;
				});
			},
			loadFaceSvcImage() {
				let ths = this;
				window.ax({
					mathod: 'get',
					url: 'api/v1/facesvc/getfaceimage?idno=' + ths.data.info.idno,
					responseType: 'blob'
				}).then(rsp => {
					const {
						data,
						headers
					} = rsp;
					const blob = new Blob([data], {
						type: headers['content-type']
					});
					ths.blobToBase64(blob).then(r => {
						ths.data.face.img = r;
						ths.data.face.imgType = 2;
					});
				}).catch(err => {
					console.log(err);
				});
			},
			toCropper() {
				let ths = this;
				this.$refs.takeImage.init();
				this.$refs.takeImage.setCurrentImage(ths.data.face.img);
			}
		},
		created() {
			let ths = this;
			let begin = new Date();
			let end = new Date();
			end.setMonth(end.getMonth() + 1);
			end = new Date(new Date(end.toDateFormatString('yyyy-MM-01 00:00:00')) - 1000);
			/*ths.data.daterange = [
				begin.toDateFormatString('yyyy-MM-01'),
				end.toDateFormatString('yyyy-MM-dd')
			];*/
			ths.baseJS.initPower(ths.power);
			ths.api.loadDepartmentTree(ths, 'data.depts', 'visible.loading');
			ths.api.loadAuthorizeGroup(ths, 'data.authorizeGroups', 'visible.loading', 1);
			ths.checkPrintFramesStatus();
			//ths.search(true);

			ths.api.loadAuthorizeGroup(ths, 'data.authorizeGroups', 'visible.loading', 1, d => {
				let row = {};
				var row1 = {
					label: '人脸'
				};
				var row2 = {
					label: '国密卡'
				};
				//var row3 = { label: '自行车' };
				//var row4 = { label: '车辆' };
				var checks1 = [];
				var checks2 = [];
				//var checks3 = [];
				//var checks4 = [];
				for (var i = 0; i < d.length; i++) {
					let item = d[i];
					let tId = item.topId;
					let id = 'c-' + item.id;
					let idV = 'cV-' + item.idV;
					row[id] = i;
					row[idV] = i;
					row1[id] = tId;
					row2[id] = tId;
					//row3[id] = tId;
					//row4[id] = tId;
					checks1[i] = false;
					checks2[i] = false;
					//checks3[i] = false;
					//checks4[i] = false;
				}
				ths.data.authorizeHeader = row;
				ths.data.authorizeDatas.push(row1);
				ths.data.authorizeDatas.push(row2);
				//ths.data.authorizeDatas.push(row3);
				//ths.data.authorizeDatas.push(row4);
				ths.data.authorizeChecks.push(checks1);
				ths.data.authorizeChecks.push(checks2);
				//ths.data.authorizeChecks.push(checks3);
				//ths.data.authorizeChecks.push(checks4);
			});
			ths.api.loadAuthorizeDoor(this, 'data.authorizeDoors', 'visible.loading');
		},
		mounted() {},
		components: {
			takeImage,
			takeCamera
		}
	}
</script>

<style>
	.mr10 {
		margin-right: 10px;
	}

	.handle-input {
		width: 200px;
		display: inline-block;
	}

	.handle-box {
		margin-bottom: 20px;
	}

	.left {
		float: left;
		margin-left: 10;
	}

	.right {
		float: right;
		margin-right: 10;
	}

	.handle-select {
		width: 120px;
	}

	.table {
		width: 100%;
		font-size: 14px;
	}

	.el-tree-node__content {
		height: 36px !important;
	}

	.dialog-footer {
		height: 30px;
	}
</style>
